class SiteProduct extends HTMLElement {
  connectedCallback() {
    this.thumbnails = this.querySelectorAll("[data-thumbnail]");
    this.quantityInput = this.querySelector("[data-quantity-input]");
    this.minusBtn = this.querySelector("[data-quantity-minus]");
    this.plusBtn = this.querySelector("[data-quantity-plus]");

    this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    this.handleMinus = this.handleMinus.bind(this);
    this.handlePlus = this.handlePlus.bind(this);
    this.handleSlideKeydown = this.handleSlideKeydown.bind(this);

    this.thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", this.handleThumbnailClick);
    });

    if (this.minusBtn) {
      this.minusBtn.addEventListener("click", this.handleMinus);
    }
    if (this.plusBtn) {
      this.plusBtn.addEventListener("click", this.handlePlus);
    }

    this.swiperEl = this.querySelector("swiper-component");
    if (this.swiperEl) {
      this.swiperEl.addEventListener("keydown", this.handleSlideKeydown);
    }

    this.initSwiperSync();
  }

  disconnectedCallback() {
    this.thumbnails.forEach((thumb) => {
      thumb.removeEventListener("click", this.handleThumbnailClick);
    });
    if (this.minusBtn) {
      this.minusBtn.removeEventListener("click", this.handleMinus);
    }
    if (this.plusBtn) {
      this.plusBtn.removeEventListener("click", this.handlePlus);
    }
    if (this.swiperRaf) {
      cancelAnimationFrame(this.swiperRaf);
    }
    if (this.swiperEl) {
      this.swiperEl.removeEventListener("keydown", this.handleSlideKeydown);
    }
  }

  /* ---- Swiper thumbnail sync ---- */

  initSwiperSync() {
    const swiperComponent = this.querySelector("swiper-component");
    if (!swiperComponent) return;

    const bind = () => {
      this.swiper = swiperComponent.swiper;
      this.swiper.on("slideChange", () => this.updateActiveThumbnail());
      this.updateActiveThumbnail();
    };

    if (swiperComponent.swiper) {
      bind();
      return;
    }

    // Swiper bundle loads with defer — poll until the instance is created
    const check = () => {
      if (swiperComponent.swiper) {
        bind();
        return;
      }
      this.swiperRaf = requestAnimationFrame(check);
    };
    this.swiperRaf = requestAnimationFrame(check);
  }

  handleThumbnailClick(e) {
    const thumb = e.currentTarget;
    const index = parseInt(thumb.dataset.thumbnail, 10);
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  updateActiveThumbnail() {
    if (!this.swiper) return;
    const activeIndex = this.swiper.realIndex;
    this.thumbnails.forEach((thumb) => {
      const index = parseInt(thumb.dataset.thumbnail, 10);
      thumb.setAttribute(
        "aria-current",
        index === activeIndex ? "true" : "false",
      );
    });
  }

  /* ---- Quantity ---- */

  handleMinus() {
    if (!this.quantityInput) return;
    const current = parseInt(this.quantityInput.value, 10);
    if (current > 1) {
      this.quantityInput.value = current - 1;
    }
  }

  handlePlus() {
    if (!this.quantityInput) return;
    const current = parseInt(this.quantityInput.value, 10);
    this.quantityInput.value = current + 1;
  }

  /* ---- Slide keyboard navigation ---- */

  handleSlideKeydown(e) {
    if (!this.swiper) return;
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      this.swiper.slidePrev();
    } else if (e.key === "ArrowRight") {
      e.preventDefault();
      this.swiper.slideNext();
    }
  }
}

if (!customElements.get("site-product")) {
  customElements.define("site-product", SiteProduct);
}
